import { render, staticRenderFns } from "./com_pgdinquiry.vue?vue&type=template&id=b48f61fc&scoped=true&"
import script from "./com_pgdinquiry.vue?vue&type=script&lang=js&"
export * from "./com_pgdinquiry.vue?vue&type=script&lang=js&"
import style0 from "./com_pgdinquiry.vue?vue&type=style&index=0&id=b48f61fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48f61fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VDataTable,VForm,VIcon,VProgressLinear,VSnackbar,VTextField})
